import * as React from "react"
import type { SVGProps } from "react"
const SvgHighlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13.6 14.86-2.6-2.6-5 5 2.6 2.6zm-1.17-4.03 2.6 2.6L20 8.46l-2.6-2.6zm-2.1-.7 5.4 5.4L10 21.26a1.9 1.9 0 0 1-2.8 0l-.05-.05-.08.07a2 2 0 0 1-1.4.58H2.7q-.36 0-.47-.3-.13-.3.12-.55l2.3-2.3-.05-.05q-.6-.6-.6-1.4t.6-1.4zm0 0L16 4.46a1.9 1.9 0 0 1 2.8 0l2.6 2.6a1.9 1.9 0 0 1 0 2.8l-5.67 5.67z" />
  </svg>
)
export default SvgHighlight
